<div class="header-container">
    <div class="select-container">
        <span class="refresh-label">Refresh Interval</span>
        <select [(ngModel)]="intervalTime" (change)="startIntervalLogic()">
            <option value="-1">None</option>
            <!--                Disable until we see how hard this hits the db-->
            <!--                <option value="10000">10 seconds</option>-->
            <!--                <option value="30000">30 seconds</option>-->
            <option value="60000">60 seconds</option>
            <option value="300000">5 minutes</option>
        </select>
        <a href="javascript:void(0)" (click)="getShopSessions().subscribe()" class="refresh-data" >Refresh Data</a>
        &nbsp;<span *ngIf="loading" class="shop-session-loading">Loading</span>
    </div>

    <div class="segment-control">
        <div class="segment-button"
             (click)="setActiveTab(0)"
             [class.active]="activeTab === 0">
            Visual
        </div>
        <div class="segment-button"
             (click)="setActiveTab(1)"
             [class.active]="activeTab === 1">
            Data
        </div>
        <div class="segment-button"
             (click)="setActiveTab(2)"
             [class.active]="activeTab === 2">
            Raw
        </div>
    </div>
</div>
<ssd-realtime-chart [shopSessionRealtimeList]="shopSessionRealtimeList" [shopSessionCountryRealtimeList]="shopSessionCountryRealtimeList"></ssd-realtime-chart>
<div class="segment-control">
    <div class="segment-button"
         (click)="setShopSessions(0)"
         [class.active]="sessionTab === 0">
        Recent Sessions
    </div>
    <div class="segment-button"
         (click)="setShopSessions(1)"
         [class.active]="sessionTab === 1">
        Enroll Sessions
    </div>
    <div class="segment-button"
         (click)="setShopSessions( 2)"
         [class.active]="sessionTab === 2">
        Checkout Sessions
    </div>
</div>
<div *ngIf="activeTab === 0">
    <div *ngIf="sessionTab === 0">
        <ssd-sessions [shopSessions]="recentShopSessions"></ssd-sessions>
    </div>
    <div *ngIf="sessionTab === 1">
        <ssd-sessions [shopSessions]="enrollShopSessions"></ssd-sessions>
    </div>
    <div *ngIf="sessionTab === 2">
        <ssd-sessions [shopSessions]="checkoutShopSessions"></ssd-sessions>
    </div>
</div>

<div *ngIf="activeTab === 1">
    <div *ngIf="sessionTab === 0">
        <ssd-sessions-data [shopSessions]="recentShopSessions"></ssd-sessions-data>
    </div>
    <div *ngIf="sessionTab === 1">
        <ssd-sessions-data  [shopSessions]="enrollShopSessions"></ssd-sessions-data >
    </div>
    <div *ngIf="sessionTab === 2">
        <ssd-sessions-data  [shopSessions]="checkoutShopSessions"></ssd-sessions-data >
    </div>
</div>

<div *ngIf="activeTab === 2">
    All Data in JSON
    <div *ngIf="sessionTab === 0">
        <pre>{{recentShopSessions | json}}</pre>
    </div>
    <div *ngIf="sessionTab === 1">
        <pre>{{enrollShopSessions | json}}</pre>
    </div>
    <div *ngIf="sessionTab === 2">
        <pre>{{checkoutShopSessions | json}}</pre>
    </div>
</div>
